import React from 'react';
import TicketCardList from '../Ticket/TicketCardList';
import createTheme from '../../styles/themes';
import { Outlet } from 'react-router-dom';
import './Homepage.scss';
import { useCurrentUserContext } from '../../context/UserContext';

const Homepage: React.FC = () => {
    const { profile } = useCurrentUserContext();
    const pageThemeCSS = createTheme(profile.Body_Hex_Color, profile?.Body_Style, profile?.Body_Image_Url);

    return (
        <div style={pageThemeCSS} className='home-page fullscreen'>
            <TicketCardList />
            <Outlet />
        </div>
    );
};

export default Homepage;